import React, { useState, useEffect } from 'react';
import API from "../../Services/BaseService";
import appstore from '../../assets/img/appstore.png';
import googleplay from '../../assets/img/googleplay.png';
import checkmarkred from '../../assets/img/checkmarkred.svg';
import checkmark from '../../assets/img/checkmark.svg';
import iconarrowback from '../../assets/img/ionic-ios-arrow-back.svg';
// import car from '../../assets/img/cars02.png'
import car from '../../assets/img/car.svg';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation, useParams } from "react-router-dom";
// import CarListAction from '../../src/Pages/CarList/CarListAction';
// import UrCarAction from '../UrCardetails/UrCarAction';
import UrCarAction from '../UrCar/UrCarAction';
import ReactPlayer from 'react-player';
import Loading from "../../Component/Loading/Loading";
// import OwlCarousel from 'react-owl-carousel';
// import 'owl.carousel/dist/assets/owl.carousel.css';
// import 'owl.carousel/dist/assets/owl.theme.default.css';
// import 'react-multi-carousel/lib/styles.css';
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import PageNotFound from '../FallBackUI/PageNotFound';
import moment from 'moment';

const Inspection = (props) => {

    // const successData = useSelector(state => state.LoginReducer.payload);
    const successData = useSelector(state => state.LoginReducer.payload);

    const history = useHistory();
    const dispatch = useDispatch();

    const [loading, setLoading] = useState(true);
    const [inspection, setInspection] = useState("");
    const [interiorMedia, setInteriorMedia] = useState("");
    const [exteriorMedia, setExteriorMedia] = useState("");
    const [mechanicalMedia, setMechanicalMedia] = useState("");
    const [footawayvideo, setFootawayvideo] = useState("");
    const [insidecarvideo, setinsidecarvideo] = useState("");
    const [smokesilencervideo, setsmokesilencervideo] = useState("");
    const [OthersmechanicalMedia, setOthersMechanicalMedia] = useState("");

    const [tiresWheelsMedia, setTiresWheelsMedia] = useState("");
    const [powerTrainMedia, setPowerTrainMedia] = useState("");
    const [testDriveMedia, setTestDriveMedia] = useState("");
    const [testDrive, setTestDrive] = useState("");
    const [testdrivevideo, setTestdrivevideo] = useState("");

    const [images, setImages] = useState("");
    const [exteriorImages, setExteriorImages] = useState("");
    const [exteriorPanelImages, setExteriorPanelImages] = useState("");
    const [interiorImages, setInteriorImages] = useState("");
    console.log('Interior Images:', interiorImages);
    const [errors, setErrors] = useState("");
    const [errorFlag, setErrorFlag] = useState(false)
    const responsive = {
        0: { items: 1 },
        568: { items: 2 },
        1024: { items: 3 },
        1200: { items: 4 },
    
      };
    const { id } = props.location.state;

    const getInspectionDetail = () => {
        let request = {
            car_id: id,
            seller_id: successData.seller_id,
            seller_token: successData.seller_token,
        }
        API.post('inspection/condition', request).then(res => {
            // console.log("response",res.data.data);
            if (res.data.success === true) {
                setInspection(res.data?.data);
            }
            else {
                setErrors(res.data.error.name)
                setErrorFlag(true)
            }
        }).catch(function (error) {
            if (error.response) {
                setErrors(error.response.data.error)
                setErrorFlag(true)
            }
        });
    }

    const ExteriorMedia = () => {
        let request = {
            car_id: id,
            seller_id: successData.seller_id,
            seller_token: successData.seller_token,
        }
        API.post('exterior_media/condition', request).then(res => {
            if (res.data.success === true) {
                setExteriorMedia(res.data?.data);
            }
            else {
                setErrors(res.data.error.name)
                setErrorFlag(true)
            }

        }).catch(function (error) {
            if (error.response) {
                setErrors(error.response.data.error)
                setErrorFlag(true)
            }
        });

    }

    useEffect(() => {
        handleImages();
    }, []);

    const handleImages = async () => {
        let request = {
            car_id: id,
            seller_id: successData.seller_id,
            seller_token: successData.seller_token,
        }
        await API.post('carinspectionview/condition', request).then(res => {
            if (res.data.success === true) {
                setImages(res.data.data?.accept);
                setExteriorImages(res.data.data?.ExteriorImages);
                setExteriorPanelImages(res.data.data?.ExteriorPanelImages);
                setInteriorImages(res.data.data?.InteriorImages);

            }
            else {
                setErrors(res.data.error.name)
                setErrorFlag(true)
            }

        }).catch(function (error) {
            if (error.response) {
                setErrors(error.response.data.error)
                setErrorFlag(true)
            }
        });

    }

    const InteriorMedia = () => {
        let request = {
            car_id: id,
            seller_id: successData.seller_id,
            seller_token: successData.seller_token,
        }
        API.post('interior_media/condition', request).then(res => {
            if (res.data.success === true) {
                setInteriorMedia(res.data?.data);
            }
            else {
                setErrors(res.data.error.name)
                setErrorFlag(true)
            }
        }).catch(function (error) {
            if (error.response) {
                setErrors(error.response.data.error)
                setErrorFlag(true)
            }
        });
    }

    const MechanicalMedia = () => {
        let request = {
            car_id: id,
            seller_id: successData.seller_id,
            seller_token: successData.seller_token,
        }
        API.post('mechanical_media/condition', request).then(res => {
            if (res.data.success === true) {
                setMechanicalMedia(res.data?.data);
                setFootawayvideo(res.data?.data.footawayvideo);
                setinsidecarvideo(res.data?.data.insidecarvideo);
                setsmokesilencervideo(res.data?.data.smokesilencervideo);
                setOthersMechanicalMedia(res.data?.data.Others);

            }
            else {
                setErrors(res.data.error.name)
                setErrorFlag(true)
            }
        }).catch(function (error) {
            if (error.response) {
                setErrors(error.response.data.error)
                setErrorFlag(true)
            }
        });
    }

    const TiresWheelsMedia = () => {
        let request = {
            car_id: id,
            seller_id: successData.seller_id,
            seller_token: successData.seller_token,
        }
        API.post('tireswheels_media/condition', request).then(res => {
            if (res.data.success === true) {
                setTiresWheelsMedia(res.data?.data);
            }
            else {
                setErrors(res.data.error.name)
                setErrorFlag(true)
            }

        }).catch(function (error) {
            if (error.response) {
                setErrors(error.response.data.error)
                setErrorFlag(true)
            }
        });
    }

    const PowerTrainMedia = () => {
        let request = {
            car_id: id,
            seller_id: successData.seller_id,
            seller_token: successData.seller_token,
        }
        API.post('power_train_media/condition', request).then(res => {
            if (res.data.success === true) {
                setPowerTrainMedia(res.data?.data);
            }
            else {
                setErrors(res.data.error.name)
                setErrorFlag(true)
            }


        }).catch(function (error) {
            if (error.response) {
                setErrors(error.response.data.error)
                setErrorFlag(true)
            }
        });
    }

    const TestDriveMedia = () => {
        let request = {
            car_id: id,
            seller_id: successData.seller_id,
            seller_token: successData.seller_token,
        }
        API.post('testdrive_media/condition', request).then(res => {
            if (res.data.success === true) {
                setTestDriveMedia(res.data?.data);
                setTestdrivevideo(res.data?.data.testdrivevideo);
                setTestDrive(res.data?.data.Others);
            }
            else {
                setErrors(res.data.error.name)
                setErrorFlag(true)
            }
            setLoading(false);
        }).catch(function (error) {
            if (error.response) {
                setErrors(error.response.data.error)
                setErrorFlag(true)
                setLoading(false);
            }
        });
    }



    useEffect(() => {
        getInspectionDetail();
        ExteriorMedia();
        InteriorMedia();
        MechanicalMedia();
        TiresWheelsMedia();
        PowerTrainMedia();
        TestDriveMedia();
    }, []);



    const redirectpage = (pathid, seller_dealer_id) => {
        // e.preventDefault();
        console.log("seller_dealer_id+++++", seller_dealer_id)
        // dispatch(CarListAction.sellerid(seller_dealer_id))
        history.push({
            pathname: '/cardetail',
            state: { id: pathid, sellerDealerId: seller_dealer_id },
        });
    }
    function formatTime(value) {
        let local = ""
        let offset = ""
        local = new Date(value);
        offset = local.getTimezoneOffset();
        value = new Date(local.getTime() - offset * 60000);
        value = moment(value).format('MMMM D, YYYY hh:mm A')
        console.log(value, "yyyy");
        return value;
    }
    return (
        <div>
            {loading ? <Loading /> :
                <main id="main" class="inner-page">

                    {errorFlag === true ? <PageNotFound error={errors} /> :
                        <div id="inspectionsummery" class="inspectionsummery">
                            {/* {inspection.length>0? */}
                            <div class="container">

                                <div class="back-btn">
                                    <a class="back-btn-primary back-btn-pr" href="JavaScript:void(0)" onClick={() => history.goBack()} ><i class="bx bx-chevron-left"></i> Back</a>
                                </div>
                                <div class="inspectionsummeryblock col-lg-12">

                                    <div class="section-title">
                                        <h2>Inspection Summary</h2>
                                    </div>
                                    <div class="inspectionsummeryhead ">
                                        <h2>{inspection[0]?.make} ({inspection[0]?.model}- {inspection[0]?.year} Model)</h2>
                                        <div class="row content">
                                            <div class="col-lg-6 pt-4 pt-lg-0">
                                                <p>Inspection Date & TIME:<span>{formatTime(inspection[0]?.inspectiondate_tz)} </span></p>
                                                <p>{inspection[0]?.inspection_type == "admin" ? "Admin Name:" : "Inspector Name:"}<span>{inspection[0]?.inspection_type == "admin" ? inspection[0]?.admin_name : inspection[0]?.inspector_name}</span></p>
                                            </div>
                                            <div class="col-lg-6 pt-4 pt-lg-0">
                                                <p>Colour:<span>{inspection[0]?.color}</span></p>
                                                <p>Vin:<span>{inspection[0]?.vin_no}</span></p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row content">
                                        <div class="col-lg-12 pt-4 pt-lg-0 inspectiontableBlock">
                                            {/* <div class="inspectiontable">
                                                <table>
                                                    <thead>
                                                        <tr>
                                                            <th colspan="2" scope="colgroup">Vehicle Operable<span class="tablearrow"><img src={iconarrowback}></img></span></th>

                                                        </tr>
                                                    </thead>
                                                    <tr>
                                                        <td>Vehicle is Disabled Need To Be Towed</td>
                                                        <td><span>Yes</span></td>
                                                    </tr>
                                                </table>
                                            </div>
                                            <div class="commentsblock">
                                                <h3>Comments</h3>
                                            </div>
                                            <div class="commentstextblock">
                                                <p>{images[0]?.image_admin_comments == "null" ? "" : images[0]?.image_admin_comments}</p>
                                            </div> */}
                                            <div class="commentsblock">
                                                <h3>Images</h3>
                                            </div>
                                            <div class="ins-Image">
                                                <h5>Exterior Images</h5>
                                            </div>
                                            <div class="coveredgallery images-container">
                                                <div class="photo-gallery">
                                                    {/* <AliceCarousel  className='owl-theme row photos' */}
                                                    <AliceCarousel
                                                        mouseTracking
                                                        // items={items}
                                                        responsive={responsive}
                                                        controlsStrategy="alternate"
                                                        keyboardNavigation={exteriorImages?.length > 4 ? true : false}
                                                        // disableButtonsControls={suggestedCount > 4 ? false : true}
                                                    
                                                        loop={false} margin={10} items={4} dots={false} nav autoplay={false} navText={['<i class="icofont-block-left"></i>', '<i class="icofont-block-right"></i>']}>
                                                        {exteriorImages?.length > 0 ? exteriorImages?.map((item) =>

                                                            <div className="">
                                                                {item?.format != "image" ?

                                                                    <video autobuffer controls autoplay width='100%' className="card-img-top1 tansition"
                                                                        height='100%'>
                                                                        <source id="mp4" src={item?.image} type="video/mp4"></source>
                                                                    </video>

                                                                    : <img class="img-fluid1" src={item?.image}></img>}
                                                            </div>
                                                        ) : "No Data Found"}

                                                    </AliceCarousel>
                                                </div>
                                            </div>
                                            <div class="ins-Image">
                                                <h5>Exterior Panel Images</h5>
                                            </div>
                                            <div class="coveredgallery images-container">
                                                <div class="photo-gallery">
                                                    {/* <AliceCarousel className='owl-theme row photos' */}
                                                    <AliceCarousel
                                                        mouseTracking
                                                        // items={items}
                                                        responsive={responsive}
                                                        controlsStrategy="alternate"
                                                        keyboardNavigation={exteriorImages?.length > 4 ? true : false}
                                                        loop={false} margin={10} items={4} dots={false} nav autoplay={false} navText={['<i class="icofont-block-left"></i>', '<i class="icofont-block-right"></i>']}>
                                                        {exteriorPanelImages?.length > 0 ? exteriorPanelImages?.map((item) =>

                                                            <div className="">
                                                                {item?.format != "image" ?

                                                                    <video autobuffer controls autoplay width='100%' className="card-img-top1"
                                                                        height='100%'>
                                                                        <source id="mp4" src={item?.image} type="video/mp4"></source>
                                                                    </video>

                                                                    : <img class="img-fluid1" src={item?.image}></img>}
                                                            </div>
                                                        ) : "No Data Found"}

                                                    </AliceCarousel>
                                                </div>
                                            </div>
                                            <div class="ins-Image">
                                                <h5>Interior Images</h5>
                                            </div>
                                            <div class="coveredgallery images-container">
                                                <div class="photo-gallery">
                                                    {/* <AliceCarousel  className='owl-theme row photos' */}
                                                    <AliceCarousel
                                                        mouseTracking
                                                        // items={items}
                                                        responsive={responsive}
                                                        controlsStrategy="alternate"
                                                        keyboardNavigation={exteriorImages?.length > 4 ? true : false}

                                                        loop={false} margin={10} items={4} dots={false} nav autoplay={false} navText={['<i class="icofont-block-left"></i>', '<i class="icofont-block-right"></i>']}>
                                                        {interiorImages?.length > 0 ? interiorImages?.map((item) =>

                                                            <div className="">
                                                                {item?.format != "image" ?

                                                                    <video autobuffer controls autoplay width='100%' className="card-img-top1"
                                                                        height='100%'>
                                                                        <source id="mp4" src={item?.image} type="video/mp4"></source>
                                                                    </video>

                                                                    : <img class="img-fluid1" src={item?.image}></img>}
                                                            </div>
                                                        ) : "No Data Found"}

                                                    </AliceCarousel>
                                                </div>
                                            </div>
                                            {/* <div class="commentsblock">
                                                <h3>Comments</h3>
                                            </div>
                                            <div class="commentstextblock">
                                                <p>{inspection[0]?.image_admin_comments == "null" ? "" : inspection[0]?.image_admin_comments}</p>
                                            </div> */}
                                            <div class="inspectiontable">
                                                <table>
                                                    <thead>
                                                        <tr>
                                                            <th colspan="4" scope="colgroup">Covered Power Train<span class="tablearrow"><img src={iconarrowback}></img></span></th>

                                                        </tr>
                                                    </thead>
                                                    <tr class="inspectionbg">
                                                        <td>Covered Items</td>
                                                        <td>Covered</td>
                                                        <td>Not Covered</td>
                                                        <td>N/A</td>
                                                    </tr>

                                                    <tr class="">
                                                        <td>Engine Bottom End Noise</td>
                                                        <td><span class="tablecheck"><img src={inspection[0]?.noise == "Good" ? checkmark : ""}></img></span></td>
                                                        <td><span class="tablecheckred"><img src={inspection[0]?.noise == "Bad" ? checkmarkred : ""}></img></span></td>
                                                        <td>{inspection[0]?.noise == "not applicable" ? "-" : ""}</td>
                                                    </tr>

                                                    <tr class="">
                                                        <td>Automatic Transmission Operation</td>
                                                        <td><span class="tablecheck"><img src={inspection[0]?.auto_transmission == "Good" ? checkmark : ""}></img></span></td>
                                                        <td><span class="tablecheckred"><img src={inspection[0]?.auto_transmission == "Bad" ? checkmarkred : ""}></img></span></td>
                                                        <td>{inspection[0]?.auto_transmission == "not applicable" ? "-" : ""}</td>
                                                    </tr>
                                                    <tr class="">
                                                        <td>Transfer Case Operation</td>
                                                        <td><span class="tablecheck"><img src={inspection[0]?.transfer_case == "Good" ? checkmark : ""}></img></span></td>
                                                        <td><span class="tablecheckred"><img src={inspection[0]?.transfer_case == "Bad" ? checkmarkred : ""}></img></span></td>
                                                        <td>{inspection[0]?.transfer_case == "not applicable" ? "-" : ""}</td>
                                                    </tr>

                                                    <tr class="">
                                                        <td>Differential Operation</td>
                                                        <td><span class="tablecheck"><img src={inspection[0]?.differential == "Good" ? checkmark : ""}></img></span></td>
                                                        <td><span class="tablecheckred"><img src={inspection[0]?.differential == "Bad" ? checkmarkred : ""}></img></span></td>
                                                        <td>{inspection[0]?.differential == "not applicable" ? "-" : ""}</td>
                                                    </tr>
                                                </table>
                                            </div>
                                            <div class="commentsblock">
                                                <h3>Covered Items Images/Videos</h3>
                                            </div>
                                            <div class="coveredgallery images-container">
                                                <div class="photo-gallery">
                                                    {/* <AliceCarousel className='owl-theme row photos'  */}
                                                    <AliceCarousel
                                                        mouseTracking
                                                        // items={items}
                                                        responsive={responsive}
                                                        controlsStrategy="alternate"
                                                        keyboardNavigation={exteriorImages?.length > 4 ? true : false}
                                                        loop={false} margin={10} items={4} dots={false} nav autoplay={false} navText={['<i class="icofont-block-left"></i>', '<i class="icofont-block-right"></i>']}>
                                                        {powerTrainMedia.length > 0 ? powerTrainMedia.map((item) =>

                                                            <div className="">
                                                                {item?.format != "image" ?

                                                                    <video autobuffer controls autoplay width='100%' className="card-img-top1"
                                                                        height='100%'>
                                                                        <source id="mp4" src={item?.image} type="video/mp4"></source>
                                                                    </video>

                                                                    : <img class="img-fluid1" src={item?.image}></img>}
                                                            </div>
                                                        ) : "No Data Found"}

                                                    </AliceCarousel>
                                                </div>
                                            </div>
                                            {/* <div class="commentsblock">
                                                <h3>Comments</h3>
                                            </div>
                                            <div class="commentstextblock">
                                                <p>{inspection[0]?.carpowertraincomments}</p>
                                            </div> */}
                                            <div class="inspectiontable">
                                                <table>
                                                    <thead>
                                                        <tr>
                                                            <th colspan="4" scope="colgroup">Mechanical<span class="tablearrow"><img src={iconarrowback}></img></span></th>

                                                        </tr>
                                                    </thead>
                                                    <tr class="inspectionbg">
                                                        <td>Inspection object</td>
                                                        <td>Good</td>
                                                        <td>Bad</td>
                                                        <td>N/A</td>
                                                    </tr>

                                                    <tr class="">
                                                        <td>Engine Upper End</td>
                                                        <td><span class="tablecheck"><img src={inspection[0]?.upper_end == "Good" ? checkmark : ""}></img></span></td>
                                                        <td><span class="tablecheckred"><img src={inspection[0]?.upper_end == "Bad" ? checkmarkred : ""}></img></span></td>
                                                        <td>{inspection[0]?.upper_end == "not applicable" ? "-" : ""}</td>
                                                    </tr>
                                                    <tr class="">
                                                        <td>Engine Bottom End</td>
                                                        <td><span class="tablecheck"><img src={inspection[0]?.bottam_end == "Good" ? checkmark : ""}></img></span></td>
                                                        <td><span class="tablecheckred"><img src={inspection[0]?.bottam_end == "Bad" ? checkmarkred : ""}></img></span></td>
                                                        <td>{inspection[0]?.bottam_end == "not applicable" ? "-" : ""}</td>
                                                    </tr>
                                                    <tr class="">
                                                        <td>Catalytic Converter Present</td>
                                                        <td><span class="tablecheck"><img src={inspection[0]?.catalytic_converter == "Good" ? checkmark : ""}></img></span></td>
                                                        <td><span class="tablecheckred"><img src={inspection[0]?.catalytic_converter == "Bad" ? checkmarkred : ""}></img></span></td>
                                                        <td>{inspection[0]?.catalytic_converter == "not applicable" ? "-" : ""}</td>
                                                    </tr>

                                                    <tr class="">
                                                        <td>Heater Runs Hot</td>
                                                        <td><span class="tablecheck"><img src={inspection[0]?.heater_runs == "Good" ? checkmark : ""}></img></span></td>
                                                        <td><span class="tablecheckred"><img src={inspection[0]?.heater_runs == "Bad" ? checkmarkred : ""}></img></span></td>
                                                        <td>{inspection[0]?.heater_runs == "not applicable" ? "-" : ""}</td>
                                                    </tr>
                                                    <tr class="">
                                                        <td>A/c Runs Hot</td>
                                                        <td><span class="tablecheck"><img src={inspection[0]?.ac_runs == "Good" ? checkmark : ""}></img></span></td>
                                                        <td><span class="tablecheckred"><img src={inspection[0]?.ac_runs == "Bad" ? checkmarkred : ""}></img></span></td>
                                                        <td>{inspection[0]?.ac_runs == "not applicable" ? "-" : ""}</td>
                                                    </tr>
                                                    <tr class="">
                                                        <td>No Check Engine Light At Startup</td>
                                                        <td><span class="tablecheck"><img src={inspection[0]?.engine_light == "Good" ? checkmark : ""}></img></span></td>
                                                        <td><span class="tablecheckred"><img src={inspection[0]?.engine_light == "Bad" ? checkmarkred : ""}></img></span></td>
                                                        <td>{inspection[0]?.engine_light == "not applicable" ? "-" : ""}</td>
                                                    </tr>
                                                    <tr class="">
                                                        <td>No Abs</td>
                                                        <td><span class="tablecheck"><img src={inspection[0]?.no_ads == "Good" ? checkmark : ""}></img></span></td>
                                                        <td><span class="tablecheckred"><img src={inspection[0]?.no_ads == "Bad" ? checkmarkred : ""}></img></span></td>
                                                        <td>{inspection[0]?.no_ads == "not applicable" ? "-" : ""}</td>
                                                    </tr>
                                                    <tr class="">
                                                        <td>No SRS/Airbag Light</td>
                                                        <td><span class="tablecheck"><img src={inspection[0]?.no_srs == "Good" ? checkmark : ""}></img></span></td>
                                                        <td><span class="tablecheckred"><img src={inspection[0]?.no_srs == "Bad" ? checkmarkred : ""}></img></span></td>
                                                        <td>{inspection[0]?.no_srs == "not applicable" ? "-" : ""}</td>
                                                    </tr>
                                                    <tr class="">
                                                        <td>Differential Operation</td>
                                                        <td><span class="tablecheck"><img src={inspection[0]?.differential_operation == "Good" ? checkmark : ""}></img></span></td>
                                                        <td><span class="tablecheckred"><img src={inspection[0]?.differential_operation == "Bad" ? checkmarkred : ""}></img></span></td>
                                                        <td>{inspection[0]?.differential_operation == "not applicable" ? "-" : ""}</td>
                                                    </tr>

                                                </table>
                                            </div>
                                            <div class="commentsblock">
                                                <h3>Mechanical Images</h3>
                                            </div>
                                            <div class="mechanicalgallery images-container">

                                                <div class="ins-Image">
                                                    <h5>Inside Car Video</h5>
                                                </div>
                                                <div class="coveredgallery images-container">
                                                    <div class="photo-gallery">
                                                        {/* <AliceCarousel  className='owl-theme row photos' 
                                                         */}
                                                          <AliceCarousel
                                                        mouseTracking
                                                        // items={items}
                                                        responsive={responsive}
                                                        controlsStrategy="alternate"
                                                        keyboardNavigation={exteriorImages?.length > 4 ? true : false}
                                                            loop={false} margin={10} items={4} dots={false} nav autoplay={false} navText={['<i class="icofont-block-left"></i>', '<i class="icofont-block-right"></i>']}>
                                                            {insidecarvideo?.length > 0 ? insidecarvideo?.map((item) =>

                                                                <div className="">
                                                                    {item?.format != "image" ?

                                                                        <video autobuffer controls autoplay width='100%' className="card-img-top1"
                                                                            height='100%'>
                                                                            <source id="mp4" src={item?.image} type="video/mp4"></source>
                                                                        </video>

                                                                        : <img class="img-fluid1" src={item?.image}></img>}
                                                                </div>
                                                            ) : "No Data Found"}

                                                        </AliceCarousel>
                                                    </div>
                                                </div>

                                                <div class="ins-Image">
                                                    <h5>Foot Away Video</h5>
                                                </div>
                                                <div class="coveredgallery images-container">
                                                    <div class="photo-gallery">
                                                        {/* <AliceCarousel className='owl-theme row photos'
                                                         */}
                                                          <AliceCarousel
                                                        mouseTracking
                                                        // items={items}
                                                        responsive={responsive}
                                                        controlsStrategy="alternate"
                                                        keyboardNavigation={exteriorImages?.length > 4 ? true : false}

                                                            loop={false} margin={10} items={4} dots={false} nav autoplay={false} navText={['<i class="icofont-block-left"></i>', '<i class="icofont-block-right"></i>']}>
                                                            {footawayvideo?.length > 0 ? footawayvideo?.map((item) =>

                                                                <div className="">
                                                                    {item?.format != "image" ?

                                                                        <video autobuffer controls autoplay width='100%' className="card-img-top1"
                                                                            height='100%'>
                                                                            <source id="mp4" src={item?.image} type="video/mp4"></source>
                                                                        </video>

                                                                        : <img class="img-fluid1" src={item?.image}></img>}
                                                                </div>
                                                            ) : "No Data Found"}

                                                        </AliceCarousel>
                                                    </div>
                                                </div>

                                                <div class="ins-Image">
                                                    <h5>Smoke Silencer Video</h5>
                                                </div>
                                                <div class="coveredgallery images-container">
                                                    <div class="photo-gallery">
                                                        {/* <AliceCarousel className='owl-theme row photos'  */}
                                                        <AliceCarousel
                                                        mouseTracking
                                                        // items={items}
                                                        responsive={responsive}
                                                        controlsStrategy="alternate"
                                                        keyboardNavigation={exteriorImages?.length > 4 ? true : false}

                                                            loop={false} margin={10} items={4} dots={false} nav autoplay={false} navText={['<i class="icofont-block-left"></i>', '<i class="icofont-block-right"></i>']}>
                                                            {smokesilencervideo?.length > 0 ? smokesilencervideo?.map((item) =>

                                                                <div className="">
                                                                    {item?.format != "image" ?

                                                                        <video autobuffer controls autoplay width='100%' className="card-img-top1"
                                                                            height='100%'>
                                                                            <source id="mp4" src={item?.image} type="video/mp4"></source>
                                                                        </video>

                                                                        : <img class="img-fluid1" src={item?.image}></img>}
                                                                </div>
                                                            ) : "No Data Found"}

                                                        </AliceCarousel>
                                                    </div>
                                                </div>

                                                <div class="ins-Image">
                                                    <h5>Mechanical Images/Videos</h5>
                                                </div>
                                                <div class="coveredgallery images-container">
                                                    <div class="photo-gallery">
                                                        {/* <AliceCarousel  className='owl-theme row photos'  */}
                                                        <AliceCarousel
                                                        mouseTracking
                                                        // items={items}
                                                        responsive={responsive}
                                                        controlsStrategy="alternate"
                                                        keyboardNavigation={exteriorImages?.length > 4 ? true : false}

                                                            loop={false} margin={10} items={4} dots={false} nav autoplay={false} navText={['<i class="icofont-block-left"></i>', '<i class="icofont-block-right"></i>']}>
                                                            {OthersmechanicalMedia?.length > 0 ? OthersmechanicalMedia?.map((item) =>

                                                                <div className="">
                                                                    {item?.format != "image" ?

                                                                        <video autobuffer controls autoplay width='100%' className="card-img-top1"
                                                                            height='100%'>
                                                                            <source id="mp4" src={item?.image} type="video/mp4"></source>
                                                                        </video>

                                                                        : <img class="img-fluid1" src={item?.image}></img>}
                                                                </div>
                                                            ) : "No Data Found"}

                                                        </AliceCarousel>
                                                    </div>
                                                </div>

                                            </div>
                                            {/* <div class="commentsblock">
                                                <h3>Comments</h3>
                                            </div>
                                            <div class="commentstextblock">
                                                <p>{inspection[0]?.mechanicalcomments}</p>
                                            </div> */}
                                            <div class="inspectiontable">
                                                <table>
                                                    <thead>
                                                        <tr>
                                                            <th colspan="4" scope="colgroup">Tires & Wheels<span class="tablearrow"><img src={iconarrowback}></img></span></th>

                                                        </tr>
                                                    </thead>
                                                    <tr class="inspectionbg">
                                                        <td>Inspection object</td>
                                                        <td>Good</td>
                                                        <td>Bad</td>
                                                        <td>N/A</td>
                                                    </tr>

                                                    <tr class="">
                                                        <td>5/32 Tread Depth</td>
                                                        <td><span class="tablecheck"><img src={inspection[0]?.tread_depth == "Good" ? checkmark : ""}></img></span></td>
                                                        <td><span class="tablecheckred"><img src={inspection[0]?.tread_depth == "Bad" ? checkmarkred : ""}></img></span></td>
                                                        <td>{inspection[0]?.tread_depth == "not applicable" ? "-" : ""}</td>
                                                    </tr>

                                                    <tr class="">
                                                        <td>Four Tires Condition</td>
                                                        <td><span class="tablecheck"><img src={inspection[0]?.four_tires_condition == "Good" ? checkmark : ""}></img></span></td>
                                                        <td><span class="tablecheckred"><img src={inspection[0]?.four_tires_condition == "Bad" ? checkmarkred : ""}></img></span></td>
                                                        <td>{inspection[0]?.four_tires_condition == "not applicable" ? "-" : ""}</td>
                                                    </tr>

                                                    <tr class="">
                                                        <td>Any Scratches On The Wheels</td>
                                                        <td><span class="tablecheck"><img src={inspection[0]?.scratches == "Good" ? checkmark : ""}></img></span></td>
                                                        <td><span class="tablecheckred"><img src={inspection[0]?.scratches == "Bad" ? checkmarkred : ""}></img></span></td>
                                                        <td>{inspection[0]?.scratches == "not applicable" ? "-" : ""}</td>
                                                    </tr>
                                                </table>
                                            </div>
                                            <div class="commentsblock">
                                                <h3>Tires & Wheels Images</h3>
                                            </div>
                                            <div class="tiresgallery images-container">
                                                <div class="photo-gallery">
                                                    {/* <AliceCarousel  className='owl-theme row photos' */}
                                                    <AliceCarousel
                                                        mouseTracking
                                                        // items={items}
                                                        responsive={responsive}
                                                        controlsStrategy="alternate"
                                                        keyboardNavigation={exteriorImages?.length > 4 ? true : false}

                                                        loop={false} margin={10} items={4} dots={false} nav autoplay={false} navText={['<i class="icofont-block-left"></i>', '<i class="icofont-block-right"></i>']}>
                                                        {tiresWheelsMedia.length > 0 ? tiresWheelsMedia.map((item) =>
                                                            <div class="">
                                                                {item?.format != "image" ?
                                                                    <video autobuffer controls autoplay width='100%' className="card-img-top1"
                                                                        height='100%'>
                                                                        <source id="mp4" src={item?.image} type="video/mp4"></source>
                                                                    </video>
                                                                    : <img class="img-fluid1" src={item?.image}></img>}
                                                            </div>
                                                        ) : "No Data Found"}

                                                    </AliceCarousel>
                                                </div>
                                            </div>
                                            {/* <div class="commentsblock">
                                                <h3>Comments</h3>
                                            </div>
                                            <div class="commentstextblock">
                                                <p>{inspection[0]?.tireswheelscomments}</p>
                                            </div> */}
                                            <div class="inspectiontable">
                                                <table>
                                                    <thead>
                                                        <tr>
                                                            <th colspan="4" scope="colgroup">Exterior<span class="tablearrow"><img src={iconarrowback}></img></span></th>

                                                        </tr>
                                                    </thead>
                                                    <tr class="inspectionbg">
                                                        <td>Inspection object</td>
                                                        <td>Good</td>
                                                        <td>Bad</td>
                                                        <td>N/A</td>
                                                    </tr>

                                                    <tr class="">
                                                        <td>No Visible Rust</td>
                                                        <td><span class="tablecheck"><img src={inspection[0]?.visible_rust == "Good" ? checkmark : ""}></img></span></td>
                                                        <td><span class="tablecheckred"><img src={inspection[0]?.visible_rust == "Bad" ? checkmarkred : ""}></img></span></td>
                                                        <td>{inspection[0]?.visible_rust == "not applicable" ? "-" : ""}</td>
                                                    </tr>

                                                    <tr class="">
                                                        <td>No Colour Fade</td>
                                                        <td><span class="tablecheck"><img src={inspection[0]?.color_fade == "Good" ? checkmark : ""}></img></span></td>
                                                        <td><span class="tablecheckred"><img src={inspection[0]?.color_fade == "Bad" ? checkmarkred : ""}></img></span></td>
                                                        <td>{inspection[0]?.color_fade == "not applicable" ? "-" : ""}</td>
                                                    </tr>
                                                    <tr class="">
                                                        <td>No Glass Damaged</td>
                                                        <td><span class="tablecheck"><img src={inspection[0]?.glass_damage == "Good" ? checkmark : ""}></img></span></td>
                                                        <td><span class="tablecheckred"><img src={inspection[0]?.glass_damage == "Bad" ? checkmarkred : ""}></img></span></td>
                                                        <td>{inspection[0]?.glass_damage == "not applicable" ? "-" : ""}</td>
                                                    </tr>

                                                    <tr class="">
                                                        <td>No Exterior Scratches</td>
                                                        <td><span class="tablecheck"><img src={inspection[0]?.scratches == "Good" ? checkmark : ""}></img></span></td>
                                                        <td><span class="tablecheckred"><img src={inspection[0]?.scratches == "Bad" ? checkmarkred : ""}></img></span></td>
                                                        <td>{inspection[0]?.scratches == "not applicable" ? "-" : ""}</td>
                                                    </tr>

                                                    <tr class="">
                                                        <td>No Side Mirror Damage</td>
                                                        <td><span class="tablecheck"><img src={inspection[0]?.side_mirror == "Good" ? checkmark : ""}></img></span></td>
                                                        <td><span class="tablecheckred"><img src={inspection[0]?.side_mirror == "Bad" ? checkmarkred : ""}></img></span></td>
                                                        <td>{inspection[0]?.side_mirror == "not applicable" ? "-" : ""}</td>
                                                    </tr>
                                                </table>
                                            </div>
                                            <div class="commentsblock">
                                                <h3>Exterior Images</h3>
                                            </div>
                                            <div class="exteriorgallery images-container">
                                                <div class="photo-gallery">
                                                    {/* <AliceCarousel  className='owl-theme row photos' */}
                                                    <AliceCarousel
                                                        mouseTracking
                                                        // items={items}
                                                        responsive={responsive}
                                                        controlsStrategy="alternate"
                                                        keyboardNavigation={exteriorImages?.length > 4 ? true : false}
                                                        
                                                        loop={false} margin={10} items={4} dots={false} nav autoplay={false} navText={['<i class="icofont-block-left"></i>', '<i class="icofont-block-right"></i>']}>
                                                        {exteriorMedia.length > 0 ? exteriorMedia.map((item) =>
                                                            <div class="">
                                                                {item?.format != "image" ?
                                                                    <video autobuffer controls autoplay width='100%' className="card-img-top1"
                                                                        height='100%'>
                                                                        <source id="mp4" src={item?.image} type="video/mp4"></source>
                                                                    </video>
                                                                    : <img class="img-fluid1" src={item?.image}></img>}
                                                            </div>
                                                        ) : "No Data Found"}

                                                    </AliceCarousel>
                                                </div>
                                            </div>
                                            {/* <div class="commentsblock">
                                                <h3>Comments</h3>
                                            </div>
                                            <div class="commentstextblock">
                                                <p>{inspection[0]?.exteriorcomments}</p>
                                            </div> */}
                                            <div class="inspectiontable">
                                                <table>
                                                    <thead>
                                                        <tr>
                                                            <th colspan="4" scope="colgroup">Interior<span class="tablearrow"><img src={iconarrowback}></img></span></th>

                                                        </tr>
                                                    </thead>
                                                    <tr class="inspectionbg">
                                                        <td>Inspection object</td>
                                                        <td>Good</td>
                                                        <td>Bad</td>
                                                        <td>N/A</td>
                                                    </tr>

                                                    <tr class="">
                                                        <td>No Visible Damage</td>
                                                        <td><span class="tablecheck"><img src={inspection[0]?.visible_damage == "Good" ? checkmark : ""}></img></span></td>
                                                        <td><span class="tablecheckred"><img src={inspection[0]?.visible_damage == "Bad" ? checkmarkred : ""}></img></span></td>
                                                        <td>{inspection[0]?.visible_damage == "not applicable" ? "-" : ""}</td>
                                                    </tr>

                                                    <tr class="">
                                                        <td>Frond Seat Conditions</td>
                                                        <td><span class="tablecheck"><img src={inspection[0]?.front_seat == "Good" ? checkmark : ""}></img></span></td>
                                                        <td><span class="tablecheckred"><img src={inspection[0]?.front_seat == "Bad" ? checkmarkred : ""}></img></span></td>
                                                        <td>{inspection[0]?.front_seat == "not applicable" ? "-" : ""}</td>
                                                    </tr>
                                                    <tr class="">
                                                        <td>Back Seat Condition</td>
                                                        <td><span class="tablecheck"><img src={inspection[0]?.back_seat == "Good" ? checkmark : ""}></img></span></td>
                                                        <td><span class="tablecheckred"><img src={inspection[0]?.back_seat == "Bad" ? checkmarkred : ""}></img></span></td>
                                                        <td>{inspection[0]?.back_seat == "not applicable" ? "-" : ""}</td>
                                                    </tr>

                                                    <tr class="">
                                                        <td>No Major Visible Damage</td>
                                                        <td><span class="tablecheck"><img src={inspection[0]?.major_damage == "Good" ? checkmark : ""}></img></span></td>
                                                        <td><span class="tablecheckred"><img src={inspection[0]?.major_damage == "Bad" ? checkmarkred : ""}></img></span></td>
                                                        <td>{inspection[0]?.major_damage == "not applicable" ? "-" : ""}</td>
                                                    </tr>
                                                </table>
                                            </div>
                                            <div class="commentsblock">
                                                <h3>Interior Images</h3>
                                            </div>
                                            <div class="interiorgallery images-container">
                                                <div class="photo-gallery">
                                                    <AliceCarousel /* className='owl-theme row photos' */
                                                        loop={false} margin={10} items={4} dots={false} nav autoplay={false} navText={['<i class="icofont-block-left"></i>', '<i class="icofont-block-right"></i>']}>
                                                        {interiorMedia.length > 0 ? interiorMedia.map((item) =>
                                                            <div class="">
                                                                {item?.format != "image" ?
                                                                    <video autobuffer controls autoplay width='100%' className="card-img-top1"
                                                                        height='100%'>
                                                                        <source id="mp4" src={item?.image} type="video/mp4"></source>
                                                                    </video>
                                                                    : <img class="img-fluid1" src={item?.image}></img>}
                                                            </div>
                                                        ) : "No Data Found"}

                                                    </AliceCarousel>
                                                </div>
                                            </div>
                                            {/* <div class="commentsblock">
                                                <h3>Comments</h3>
                                            </div>
                                            <div class="commentstextblock">
                                                <p>{inspection[0]?.interiorcomments}</p>
                                            </div> */}
                                            <div class="inspectiontable">
                                                <table>
                                                    <thead>
                                                        <tr>
                                                            <th colspan="4" scope="colgroup">Test Drive<span class="tablearrow"><img src={iconarrowback}></img></span></th>

                                                        </tr>
                                                    </thead>
                                                    <tr class="inspectionbg">
                                                        <td>Inspection object</td>
                                                        <td>Good</td>
                                                        <td>Bad</td>
                                                        <td>N/A</td>
                                                    </tr>
                                                    <tr class="">
                                                        <td>Automatic Transmission</td>
                                                        <td><span class="tablecheck"><img src={inspection[0]?.automatic_transmission == "Good" ? checkmark : ""}></img></span></td>
                                                        <td><span class="tablecheckred"><img src={inspection[0]?.automatic_transmission == "Bad" ? checkmarkred : ""}></img></span></td>
                                                        <td>{inspection[0]?.automatic_transmission == "not applicable" ? "-" : ""}</td>
                                                    </tr>

                                                    <tr class="">
                                                        <td>Manual Transmission</td>
                                                        <td><span class="tablecheck"><img src={inspection[0]?.manual_transmission == "Good" ? checkmark : ""}></img></span></td>
                                                        <td><span class="tablecheckred"><img src={inspection[0]?.manual_transmission == "Bad" ? checkmarkred : ""}></img></span></td>
                                                        <td>{inspection[0]?.manual_transmission == "not applicable" ? "-" : ""}</td>
                                                    </tr>

                                                    <tr class="">
                                                        <td>Exilator Level</td>
                                                        <td><span class="tablecheck"><img src={inspection[0]?.exilator_level == "Good" ? checkmark : ""}></img></span></td>
                                                        <td><span class="tablecheckred"><img src={inspection[0]?.exilator_level == "Bad" ? checkmarkred : ""}></img></span></td>
                                                        <td>{inspection[0]?.exilator_level == "not applicable" ? "-" : ""}</td>
                                                    </tr>

                                                    <tr class="">
                                                        <td>Breaking Senses</td>
                                                        <td><span class="tablecheck"><img src={inspection[0]?.breaking_senses == "Good" ? checkmark : ""}></img></span></td>
                                                        <td><span class="tablecheckred"><img src={inspection[0]?.breaking_senses == "Bad" ? checkmarkred : ""}></img></span></td>
                                                        <td>{inspection[0]?.breaking_senses == "not applicable" ? "-" : ""}</td>
                                                    </tr>
                                                    <tr class="">
                                                        <td>Steering Controls</td>
                                                        <td><span class="tablecheck"><img src={inspection[0]?.steering_controls == "Good" ? checkmark : ""}></img></span></td>
                                                        <td><span class="tablecheckred"><img src={inspection[0]?.steering_controls == "Bad" ? checkmarkred : ""}></img></span></td>
                                                        <td>{inspection[0]?.steering_controls == "not applicable" ? "-" : ""}</td>
                                                    </tr>
                                                    <tr class="">
                                                        <td>Transfer Case</td>
                                                        <td><span class="tablecheck"><img src={inspection[0]?.transfer_case == "Good" ? checkmark : ""}></img></span></td>
                                                        <td><span class="tablecheckred"><img src={inspection[0]?.transfer_case == "Bad" ? checkmarkred : ""}></img></span></td>
                                                        <td>{inspection[0]?.transfer_case == "not applicable" ? "-" : ""}</td>
                                                    </tr>
                                                    <tr class="">
                                                        <td>Differential</td>
                                                        <td><span class="tablecheck"><img src={inspection[0]?.test_differential == "Good" ? checkmark : ""}></img></span></td>
                                                        <td><span class="tablecheckred"><img src={inspection[0]?.test_differential == "Bad" ? checkmarkred : ""}></img></span></td>
                                                        <td>{inspection[0]?.test_differential == "not applicable" ? "-" : ""}</td>
                                                    </tr>


                                                </table>
                                            </div>
                                            <div class="commentsblock">
                                                <h3>Test Drive</h3>
                                            </div>
                                            <div class="ins-Image">
                                                <h5>Test Drive Videos</h5>
                                            </div>
                                            <div class="interiorgallery images-container">
                                                <div class="photo-gallery">
                                                    <AliceCarousel /* className='owl-theme row photos' */
                                                        loop={false} margin={10} items={4} dots={false} nav autoplay={false} navText={['<i class="icofont-block-left"></i>', '<i class="icofont-block-right"></i>']}>
                                                        {testdrivevideo.length > 0 ? testdrivevideo.map((item) =>
                                                            <div class="">
                                                                {item?.format != "image" ?
                                                                    <video autobuffer controls autoplay width='100%' className="card-img-top1"
                                                                        height='100%'>
                                                                        <source id="mp4" src={item?.image} type="video/mp4"></source>
                                                                    </video>
                                                                    : <img class="img-fluid1" src={item?.image}></img>}
                                                            </div>
                                                        ) : "No Data Found"}

                                                    </AliceCarousel>
                                                </div>
                                            </div>
                                            <div class="ins-Image">
                                                <h5>Multiple Images/Videos</h5>
                                            </div>
                                            <div class="interiorgallery images-container">
                                                <div class="photo-gallery">
                                                    <AliceCarousel /* className='owl-theme row photos' */
                                                        loop={false} margin={10} items={4} dots={false} nav autoplay={false} navText={['<i class="icofont-block-left"></i>', '<i class="icofont-block-right"></i>']}>
                                                        {testDrive.length > 0 ? testDrive.map((item) =>
                                                            <div class="">
                                                                {item?.format != "image" ?
                                                                    <video autobuffer controls autoplay width='100%' className="card-img-top1"
                                                                        height='100%'>
                                                                        <source id="mp4" src={item?.image} type="video/mp4"></source>
                                                                    </video>
                                                                    : <img class="img-fluid1" src={item?.image}></img>}
                                                            </div>
                                                        ) : "No Data Found"}

                                                    </AliceCarousel>
                                                </div>
                                            </div>
                                            {/* <div class="commentsblock">
                                                <h3>Comments</h3>
                                            </div>
                                            <div class="commentstextblock">
                                                <p>{inspection[0]?.testdrivecomments}</p>
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* :"No data found"} */}
                        </div>}

                    <div class="inspectionbottom-back-btn">
                        <a class="back-btn-primary" onClick={() => history.goBack()}><i class="bx bx-chevron-left"></i> Back</a>
                    </div>


                    <section id="playstoreBlock" class="playstoreBlock">
                        <div class="container">


                            <div class="row content">
                                <div class="col-lg-12">
                                    <img src={appstore} ></img>
                                    <img itemExterior Imagessrc={googleplay} ></img>

                                </div>

                            </div>

                        </div>
                    </section>





                </main>

            }
        </div>
    )
}
export default Inspection;